import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import EnVrac from './components/Homepage/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      EnVrac,
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
